export { default as Onboardings } from './onboardings.container';
export { OnboardingDetailsComponent as OnboardingsDetails } from './onboardingsDetails.component';
